export default "__VITE_ASSET__CpnQUd$2__"